// extracted by mini-css-extract-plugin
module.exports = {"Display":"DrumPad_Display__26R1g","RightPanel":"DrumPad_RightPanel__2-375"};